import { InjectionToken } from '@angular/core';

export const TRANSLATE_SOURS = new InjectionToken<string>('TRANSLATE_SOURS');
